<template>
  <header
    class="pos-header"
    :style="
      routeName === '/pos-login'
        ? 'margin-bottom:0px;padding-left:10px;padding-top:10px'
        : 'margin-bottom:0px'
    "
  >
    <div
      class="row"
      :style="
        routeName === '/pos-login' ? 'margin-bottom:0px' : 'margin-bottom:0px'
      "
    >
      <div class="col-lg-12 col-12 alignment-header">
        <div class="pos-header-left">
          <span class="pos-header-logo" v-if="routeName !== '/pos-login'">
            <img
              src="@/assets/img/logos/Nuvio_Black.png"
              width="52"
              height="auto"
            />
          </span>
          <div
            v-if="
              ((section && section.movieDetail) ||
                routeName === '/pos-booking' ||
                routeName.includes('/pos-seat')) &&
              accessLimitation == 'SUPER'
            "
            class="pos-tabs"
          >
            <router-link
              v-if="showSchedulesTab"
              to="/pos-booking"
              class="active text-decoration-none"
              >Schedules
            </router-link>
            <router-link
              v-if="showFnbTab"
              to
              class="text-decoration-none"
              @click.native.prevent="onSwitchToFnb()"
              >FNB</router-link
            >
            <!-- v-if="SHOW_GAMES_MODULE == 'Y'" -->
            <router-link
              to
              v-if="showGamesTab"
              class="text-decoration-none"
              @click.native.prevent="onSwitchToGames()"
              >Games</router-link
            >
            <router-link
              v-if="SHOW_MERCHANDISE_MODULE == 'Y'"
              to="/merchandise"
              class="text-decoration-none"
              >MERCH</router-link
            >
          </div>
        </div>

        <div class="pos-header-center" v-if="routeName == '/pos-booking'">
          <section
            class="pos_movie_search_n_filters__nav"
            :class="!disableClick ? 'disabled-click' : ''"
          >
            <article class="movie_view_type_selector_new">
              <span
                @click="onChangeFilter($event, 'movie')"
                :class="selectedFilterName === 'movie' ? 'active' : ''"
              >
                {{ $tc("movie", 1) }}
              </span>
              <span
                @click="onChangeFilter($event, 'date')"
                :class="selectedFilterName === 'date' ? 'active' : ''"
              >
                {{ $t("date") }}
              </span>
              <span
                @click="onChangeFilter($event, 'screen')"
                :class="selectedFilterName === 'screen' ? 'active' : ''"
              >
                {{ $tc("screen", 1) }}
              </span>
              <span
                @click="onChangeFilter($event, 'language')"
                :class="selectedFilterName === 'language' ? 'active' : ''"
              >
                {{ $tc("language", 1) }}
              </span>
            </article>
          </section>
          <b-dropdown
            right
            no-caret
            class="pos-sort-dropdown"
            variant="pos-dropdown"
            :class="!disableClick ? 'disabled-click' : ''"
            toggle-class="pos-sort-toggle"
            menu-class="pos-sort-menu"
            :title="'Sort Shows'"
          >
            <template v-slot:button-content>
              <svg
                class="pos-sort-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 7H15M4 12H12M4 17H9"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M18 7V17M18 17L15.5 14.5M18 17L20.5 14.5"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span class="pos-sort-label">{{ activeSortLabel }}</span>
              <span class="pos-sort-arrow">{{ sortArrow }}</span>
            </template>

            <b-dropdown-header class="pos-sort-header">
              Sort Shows By
            </b-dropdown-header>
            <b-dropdown-item
              v-for="option in sortOptions"
              :key="option.key"
              :active="sortBy === option.key"
              @click="onSelectSort(option.key)"
            >
              <span class="pos-sort-item">
                <span>{{ option.label }}</span>
                <span v-if="sortBy === option.key" class="pos-sort-item-arrow">
                  {{ sortArrow }}
                </span>
              </span>
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="onToggleSortOrder()">
              <span class="pos-sort-item">
                <span>{{
                  sortOrder === "asc" ? "Ascending" : "Descending"
                }}</span>
                <span class="pos-sort-item-arrow">⇅</span>
              </span>
            </b-dropdown-item>
          </b-dropdown>

          <button
            type="button"
            class="pos-filter-btn"
            @click="onClickHandler('Filter')"
            :class="!disableClick ? 'disabled-click' : ''"
            :title="$tc('Filters')"
          >
            <svg
              class="pos-filter-icon"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>

        <div class="pos-header-right" v-if="routeName !== '/pos-login'">
          <b-form-input
            v-if="routeName == '/pos-booking' && false"
            :class="!disableClick ? 'disabled-click' : ''"
            v-model="searchValue"
            placeholder="Search By Movie"
            class="search_icon"
            type="search"
            id="searchMovie"
            @input="onSearchMovie($event)"
          ></b-form-input>
          <VkeyboardFloat
            :ID="'searchMovie'"
            :onClickFun="() => (showVKeyboard = !showVKeyboard)"
          />
          <Vkeyboard
            :inputName="'searchHeader'"
            :initialValue="searchValue"
            @changeKeyboardInput="searchValue = $event"
            @onChangeEvent="onSearchMovie($event)"
            :showOrHide="showVKeyboard"
            @onClickClose="
              () => {
                showVKeyboard = false;
              }
            "
          />

          <button
            type="button"
            class="pos-header-lock-btn"
            @click="lockWorkstation()"
            title="Lock Workstation"
          >
            <svg
              class="pos-header-lock-icon"
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="4"
                y="10"
                width="16"
                height="11"
                rx="2.5"
                stroke="currentColor"
                stroke-width="2"
              />
              <path
                d="M7 10V7a5 5 0 0110 0v3"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
              <circle cx="12" cy="15.5" r="1.5" fill="currentColor" />
            </svg>
          </button>

          <div class="pos-header-datetime">
            <span class="pos-header-date">{{ currentDate }}</span>
            <span class="pos-header-datetime-sep">|</span>
            <span class="pos-header-time">{{
              (epixClient && twelhrtime) || currentTime
            }}</span>
          </div>

          <div
            v-if="
              onChangeScreen &&
              enableSyncDualDisplay &&
              routeName.includes('/pos-seatlayout')
            "
          >
            <button
              class="btn-pos-menu d-flex align-items-center"
              style="border: none"
              v-on:click="posHeaderAction('refreshDualDisplay')"
            >
              <div class="svg-container">
                <div class="footer-icon-reload"></div>
              </div>
              <div>{{ "Sync Display" }}</div>
            </button>
          </div>

          <b-dropdown
            v-if="USERLOCATIONS.length > 1"
            right
            class="pos-header-dropdown"
            variant="pos-dropdown"
          >
            <template v-slot:button-content>
              <span class="pos-header-user-label">{{ getUserLocation }}</span>
            </template>
            <template>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item
                :class="
                  selectedPosUserId == users.user_id ? 'disableLocation' : ''
                "
                :disabled="selectedPosUserId == users.user_id"
                :key="userIndex"
                v-for="(users, userIndex) in USERLOCATIONS"
                @click="OnChangeUserLocation(users)"
              >
                {{ users.cine_name }}
                <div class="text-muted fs-10 p-0 m-0">
                  {{ users.first_name }}&nbsp;{{
                    users.last_name ? users.last_name : ""
                  }}
                  <span
                    v-if="selectedPosUserId == users.user_id"
                    class="font-italic"
                    >&nbsp;(Logged)</span
                  >
                </div>
              </b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
            </template>
          </b-dropdown>

          <b-dropdown
            v-if="routeName !== '/pos-login'"
            right
            class="pos-header-dropdown pos-header-user-menu"
            variant="pos-dropdown"
            @show="onCheckShift()"
          >
            <template v-slot:button-content>
              <span class="pos-header-user-label">{{ pos_user_name }}</span>
              <svg
                class="pos-header-user-icon"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="8"
                  r="3.5"
                  stroke="currentColor"
                  stroke-width="1.6"
                />
                <path
                  d="M5 19.5C5.8 16.2 8.5 14 12 14C15.5 14 18.2 16.2 19 19.5"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linecap="round"
                />
              </svg>
            </template>
            <template v-if="!loading">
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item
                v-if="
                  !isLogin &&
                  GetCinemaShiftIsActive &&
                  GetCinemaShiftIsActive === 'Y' &&
                  shiftRunning
                "
                v-on:click="onClickModal()"
                >Close Shift</b-dropdown-item
              >
              <b-dropdown-item v-if="checkClient" @click="openChrome()"
                >Manual Bills</b-dropdown-item
              >
              <!-- <b-dropdown-item @click="onChangeCacheMode()"
                  >Cache Mode
                </b-dropdown-item> -->
              <b-dropdown-divider
                v-if="
                  !isLogin &&
                  GetCinemaShiftIsActive &&
                  GetCinemaShiftIsActive === 'Y' &&
                  shiftRunning
                "
              ></b-dropdown-divider>
              <b-dropdown-item @click="openCashDrawer('openCashDraw')"
                >Open Cash Drawer</b-dropdown-item
              >
              <b-dropdown-divider></b-dropdown-divider>

              <!-- <b-dropdown-item v-if="isLogin" v-on:click="onLogout()">Logout</b-dropdown-item> -->
              <b-dropdown-item
                v-if="
                  USE_TIM_INTEGRATION == 'Y' ||
                  USE_PLAY_ALHAMRA_CARD_MACHINE == 'Y' ||
                  USE_EPIX_ASF_CARD_MACHINE == 'Y'
                "
                v-on:click="configureSetting()"
                >ECR Settings</b-dropdown-item
              >
              <b-dropdown-item v-on:click="configureCounterTypeSetting()"
                >Counter Type</b-dropdown-item
              >
              <b-dropdown-item v-on:click="configureWorkStationSetting()"
                >Workstation</b-dropdown-item
              >
              <b-dropdown-item v-on:click="configurePrintSettings()"
                >Print Settings</b-dropdown-item
              >
              <b-dropdown-divider></b-dropdown-divider>

              <b-dropdown-item v-on:click="onLogout()">Logout</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>

              <b-dropdown-item>
                <span>
                  {{ semver }} <br />
                  <!-- {{ releaseVersion }} -->
                </span>
              </b-dropdown-item>

              <b-dropdown-divider v-if="DeviceUniqueCode"></b-dropdown-divider>
              <b-dropdown-item v-if="DeviceUniqueCode">
                <!---Device Name-->
                <div class="d-flex mr-3 text-nowrap">
                  <div class="text-blue" @click="configureHardware()">
                    Device - {{ DeviceUniqueCode }}
                  </div>
                </div>
                <!---Device Name-->
              </b-dropdown-item>
              <b-dropdown-divider
                v-if="CLIENT.STAR == CLIENT_SETUP_NAME"
              ></b-dropdown-divider>
              <b-dropdown-item
                v-on:click="onClickStoreManagement()"
                v-if="CLIENT.STAR == CLIENT_SETUP_NAME"
              >
                Store Settings&nbsp;<span class="edit-pen-sm"></span>
                <br />
                <span class="fs-12 text-muted">{{
                  getUserShiftData("sm_store_name") || "Update"
                }}</span>
              </b-dropdown-item>
            </template>
            <div v-else>
              <div class="loader"></div>
            </div>
          </b-dropdown>
        </div>
      </div>

      <ManagerAuthLogin
        @AuthValid="onValidateAuth"
        :refId="'authManagerLoginPopup_posHeader'"
      />
      <ManagerAuthLogin
        :moduleName="'closeShiftAuth'"
        :onCheckAuth="onCheckAuthentication"
        :refId="'closeShiftAuth'"
      />
      <ManagerAuthLogin
        :moduleName="'openCashDraw'"
        :onCheckAuth="onCheckAuthentication"
        :refId="'openCashDraw'"
      />
      <ManagerAuthLogin
        :moduleName="'workstationSetting'"
        :onCheckAuth="onCheckAuthentication"
        :refId="'workstationSetting'"
      />
        <ManagerAuthLogin
        :moduleName="'counterTypeSetting'"
        :onCheckAuth="onCheckAuthentication"
        :refId="'counterTypeSetting'"
      />
      <ManagerAuthLogin
        :moduleName="'printSettings'"
        :onCheckAuth="onCheckAuthentication"
        :refId="'printSettings'"
      />
      <PosSettingsPopup />
      <PosPrintSettingsPopup />
      <PosHardwarePopup />
      <WorkstationPopup />
       <CounterTypePopup scope="schedule" />
      <div ref="onPrint" class="d-none">
        <div v-html="EjsData"></div>
      </div>
    </div>

    <b-modal
      id="confirmation_active_inactive"
      title="Confirmation"
      hide-footer
      hide-header
      centered
    >
      <div class="text-center pb-1 my-3">
        <p class="fs-16 mb-3">Do you want to Close Your Shift ?</p>
        <span class="mx-1"></span>
        <button
          class="btn btn-success btn-success-lg px-4 fs-14"
          v-on:click="onCloseShift()"
        >
          Yes
        </button>

        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('confirmation_active_inactive')"
        >
          Cancel
        </button>
      </div>
    </b-modal>

    <b-modal
      id="userStoreManagement"
      ref="userStoreManagement"
      title="Update Store"
      size="md"
      centered
      hide-footer
      no-fade
    >
      <div class="row h-100 versionBox">
        <div v-if="isStoreManagementLoading" class="pos-fnb-item-not-found">
          <div>
            <div>
              <b-spinner :variant="'primary'"></b-spinner>
            </div>
            <h6 class="pt-3 mb-2">Fetching Stores</h6>
            <h6>Please Wait...</h6>
          </div>
        </div>

        <template
          v-else-if="
            storeManagementArray.length > 0 && !isStoreManagementLoading
          "
        >
          <div
            v-for="(store, storeIndex) in storeManagementArray"
            :key="storeIndex"
            class="text-center mx-1"
          >
            <button
              :class="`w-100 mb-3 fs-10 noHoverBtn ${
                selectedStore && selectedStore.sm_id == store.sm_id
                  ? 'btn-blue'
                  : 'btn-outline-blue'
              }`"
              @click="
                () => {
                  selectedStore = store;
                }
              "
            >
              {{ store.sm_store_name }}
            </button>
          </div>
        </template>

        <div v-else class="pos-fnb-item-not-found">
          <div>
            <h6 class="pt-3 mb-2">Opps!</h6>
            <h6>No Store Found!</h6>
          </div>
        </div>
      </div>

      <div class="text-center" v-if="storeManagementArray.length > 0">
        <button
          class="btn-sm btn-primary my-1 text-center"
          @click="
            () => {
              updateStoreManagement(true);
              $bvModal.hide('userStoreManagement');
            }
          "
        >
          {{ $t("Update Store") }}
        </button>
      </div>
    </b-modal>

    <b-modal
      id="confirmation_store_update"
      title="Confirmation"
      hide-footer
      hide-header
      centered
    >
      <div class="text-center pb-1 my-3">
        <p class="fs-16 mb-3">Do you want to Update Store ?</p>
        <span class="mx-1"></span>
        <button
          class="btn btn-success btn-success-lg px-4 fs-14"
          v-on:click="updateStoreManagement(false)"
        >
          Yes
        </button>

        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('confirmation_store_update')"
        >
          Cancel
        </button>
      </div>
    </b-modal>
  </header>
</template>

<script>
import languages from "@/helper/Languages";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import PosSettingsPopup from "@/components/Partials/PosSettingsPopup.vue";
import PosPrintSettingsPopup from "@/components/Partials/PosPrintSettingsPopup.vue";
import WorkstationPopup from "@/components/Partials/WorkstationPopup.vue";
import CounterTypePopup from "@/components/Partials/CounterTypePopup.vue";
import PosHardwarePopup from "@/components/Partials/PosHardwareSettingsPopup.vue";
import PosService from "@/services/PosService";
import MasterService from "@/services/MasterService";
import Printd from "printd";
import { BASEURL } from "@/config/index";
import { backendSocket, EventBus } from "@/main.js";
import { createQueryString } from "@/services/ApiHelper";
import moment from "moment";
import axios from "axios";
import { CLIENT_NAMES_OBJ, CLIENT_NAME } from "@/helper/Role";
import { getHardwareId, getResourceUsageInfo } from "@/socket.io/init";
import {
  getWorkstation,
  getWorkstationNavFlags,
  WORKSTATION_UPDATED_EVENT,
} from "@/util/indexDb/workstationIndexDb";

export default {
  components: {
    Vkeyboard,
    VkeyboardFloat,
    ManagerAuthLogin,
    PosSettingsPopup,
    PosPrintSettingsPopup,
    PosHardwarePopup,
    WorkstationPopup,
    CounterTypePopup,
  },
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
    onChangeScreen: {
      type: Boolean,
      default: false, // Optional, but good to include if the prop is always required
    },
    section: {
      type: Object,
    },
    selectedFilterName: {
      type: String,
      default: "date",
    },
    onChangeFilter: {
      type: Function,
    },
    onClickHandler: {
      type: Function,
    },
    onSearchMovie: {
      type: Function,
    },
    sortBy: {
      type: String,
      default: "showtime",
    },
    sortOrder: {
      type: String,
      default: "asc",
    },
    onChangeSort: {
      type: Function,
    },
  },
  data() {
    return {
      tempCacheMode: false,
      cacheMode: false,
      fullScreen: false,
      pos_user_name: "",
      EjsData: "",
      paymentTypes: [],
      accessLimitation: "SUPER",
      selectedPosUser: "",
      selectedPosUserId: null,
      USERLOCATIONS: [],
      showVKeyboard: false,
      shiftRunning: false,
      loading: true,
      token: null,
      languages,
      selectedLanguage: "English",
      selectedCinema: "",
      DeviceUniqueCode: "",
      hardware_id: "",
      searchValue: "",
      noAuth: false,
      posShiftLog: {
        paymentTypes: [],
        grandTotal: 0,
        cine_include_shift_close: null,
        usl_id: null,
        user_shift_id: null,
      },
      currentDate: "",
      currentTime: "",
      twelhrtime: "",
      isStoreManagementLoading: false,
      storeManagementArray: [],
      selectedStore: {
        sm_id: null,
        sm_store_name: "",
      },
      workstationType: "",
    };
  },
  computed: {
    sortOptions() {
      return [
        { key: "movie", label: `${this.$tc("movie", 1)} Name` },
        { key: "showcount", label: "Show Count" },
        { key: "showtime", label: "Show Time" },
      ];
    },
    workstationNavFlags() {
      return getWorkstationNavFlags(this.workstationType);
    },
    showSchedulesTab() {
      return this.workstationNavFlags.showSchedules;
    },
    showFnbTab() {
      return this.workstationNavFlags.showFnb;
    },
    showGamesTab() {
      return (
        this.workstationNavFlags.showGames && this.SHOW_GAMES_MODULE == "Y"
      );
    },
    activeSortLabel() {
      const active = this.sortOptions.find(
        (option) => option.key === this.sortBy
      );
      return active ? active.label : "Show Time";
    },
    sortArrow() {
      return this.sortOrder === "desc" ? "↓" : "↑";
    },
    CLIENT() {
      return CLIENT_NAME;
    },
    isQfx() {
      return CLIENT_NAME.QFX == this.CLIENT_SETUP_NAME;
    },
    CACHE_MODE_POS() {
      return this.cacheModePos;
    },
    MANAGER_AUTH_FOR_CHANGES() {
      return this.$store.getters.MANAGER_AUTH_FOR_CHANGES;
    },
    SHOW_MERCHANDISE_MODULE() {
      return this.$store.getters.SHOW_MERCHANDISE_MODULE;
    },
    SHOW_GAMES_MODULE() {
      const direct = this.$store.getters.SHOW_GAMES_MODULE;
      if (String(direct || "").trim().toUpperCase() === "Y") {
        return "Y";
      }
      const options = this.$store.getters.getGlobalOptions || [];
      const row = options.find(
        (x) => String(x.go_key || "").trim() === "SHOW_GAMES_MODULE"
      );
      return row &&
        ["Y", "YES", "1", "TRUE"].includes(
          String(row.go_value || "")
            .trim()
            .toUpperCase()
        )
        ? "Y"
        : "N";
    },
    checkClient() {
      return this.authorizeClient(CLIENT_NAMES_OBJ.qfx);
    },
    getUserLocation() {
      return this.getUserDetail("cine_name");
    },
    getOrganizationDetails() {
      return this.$store.getters.getOrganizationDetails;
    },
    routeName() {
      return window.location.hash.replace("#", "");
    },
    disableClick() {
      return window.location.hash.replace("#", "").includes("pos-boo");
    },
    semver() {
      return "V 1.0.0";
    },
    GetCinemaShiftIsActive() {
      return window.localStorage.getItem("IS_SHIFT_CLOSE");
    },
    getCurrencyData() {
      return this.$store.getters.getCurrencyData;
    },
    USE_TIM_INTEGRATION() {
      return this.$store.getters.USE_TIM_INTEGRATION;
    },
    USE_PLAY_ALHAMRA_CARD_MACHINE() {
      let flag = "N";
      if (
        this.$store.getters.USE_CREDIT_CARD_MACHINE_PAYMENT == "Y" &&
        CLIENT_NAME.PLAYCINEMAS == this.CLIENT_SETUP_NAME
      ) {
        flag = "Y";
      }
      return flag;
    },
    USE_EPIX_ASF_CARD_MACHINE() {
      let flag = "N";
      if (
        this.$store.getters.USE_CREDIT_CARD_MACHINE_PAYMENT == "Y" &&
        CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME
      ) {
        flag = "Y";
      }
      return flag;
    },
    epixClient() {
      console.log("Is There", CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME);
      return CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME;
    },
    enableSyncDualDisplay() {
      return CLIENT_NAMES_OBJ.enable_sync_dual_display.includes(
        this.CLIENT_SETUP_NAME
      );
    },
  },
  beforeDestroy() {
    window.removeEventListener(
      WORKSTATION_UPDATED_EVENT,
      this.onWorkstationUpdated
    );
  },
  mounted() {
    this.tempCacheMode = this.cacheModePos;
    this.currentDate = this.getCurrentDateNew("ddd DD MMM", "calender");
    this.currentTime = this.getCurrentTime();
    this.accessLimitation = window.localStorage.getItem("USER_ROLE_NAME")
      ? window.localStorage.getItem("USER_ROLE_NAME")
      : "SUPER";
    this.DeviceUniqueCode = window.localStorage.getItem("deiviceUniqueCode")
      ? window.localStorage.getItem("deiviceUniqueCode")
      : "";
    this.getPosUserLocations();
    this.loadWorkstationNav();
    window.addEventListener(
      WORKSTATION_UPDATED_EVENT,
      this.onWorkstationUpdated
    );

    this.twelhrtime = this.twelhrtimeform;
    this.twelhrtimeform = function () {
      var twelhrtime = new Date();
      var hours = twelhrtime.getHours();
      var minutes = twelhrtime.getMinutes();
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var formattedTime = hours + ":" + minutes + " " + ampm;
      return formattedTime;
    };

    setInterval(() => {
      this.twelhrtime = this.twelhrtimeform();
    }, 1000);

    if (this.USE_PLAY_ALHAMRA_CARD_MACHINE == "Y") {
      this.loadAlhamraScriptsSequentially(null);
    }
  },
  methods: {
    onSelectSort(key) {
      // clicking the already active key flips the direction
      const order =
        key === this.sortBy
          ? this.sortOrder === "asc"
            ? "desc"
            : "asc"
          : "asc";
      this.emitSortChange(key, order);
    },
    onToggleSortOrder() {
      this.emitSortChange(
        this.sortBy,
        this.sortOrder === "asc" ? "desc" : "asc"
      );
    },
    emitSortChange(sortBy, sortOrder) {
      if (typeof this.onChangeSort === "function") {
        this.onChangeSort(sortBy, sortOrder);
      }
      this.$emit("changeSort", { sortBy, sortOrder });
    },
    async loadWorkstationNav() {
      try {
        this.workstationType = (await getWorkstation()) || "";
      } catch (e) {
        this.workstationType = "";
      }
    },
    onWorkstationUpdated(event) {
      this.workstationType =
        event && event.detail != null ? event.detail : "";
    },
    loadAlhamraScriptsSequentially(ev = null) {
      const scriptsList = ["static/AlhamaraniCard/jquery.min.js"];

      const loadScript = (src) => {
        return new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.src = src;
          script.onload = () => {
            // If it's jQuery, expose it globally (important for Electron)
            if (src.includes("jquery.min.js")) {
              window.$ = window.jQuery = jQuery;
              console.log("✅ jQuery is now globally available!");
            }
            resolve(src);
          };
          script.onerror = () =>
            reject(new Error(`Failed to load script: ${src}`));
          document.body.appendChild(script);
        });
      };

      // Load scripts one by one
      const loadSequential = async () => {
        for (const script of scriptsList) {
          try {
            console.log(`Loading ${script}...`);
            await loadScript(script);
            console.log(`${script} loaded successfully.`);
          } catch (error) {
            console.error(error.message);
            break;
          }
        }
      };

      loadSequential();
    },
    onChangeCacheMode(event) {
      this.tempCacheMode = !this.tempCacheMode;
      window.localStorage.removeItem("fnb_items_array");
      window.localStorage.removeItem("fnb_categories");
      window.localStorage.removeItem("showDataCache");
      window.localStorage.removeItem("datesArray");
      window.localStorage.setItem("cacheMode", this.tempCacheMode ? "Y" : "N");
      this.cacheMode = this.tempCacheMode ? "Y" : "N";
      this.$toasted.show(
        !this.tempCacheMode ? "Cache Mode OFF" : "Cache Mode ON"
      );
    },
    posHeaderAction: function (menu_name, authCheck = true) {
      const log_menu_name = menu_name
        .split(/(?=[A-Z])/)
        .join(" ")
        .toUpperCase();

      this.sendAuditLogs({
        action: `POS USER CLICKS HEADER MENU - ${log_menu_name}`,
        page_name: "POS HEADER MENU",
        api_name: window.location.hash,
      });
      this.onClickHandler(menu_name);
    },
    openChrome() {
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
        try {
          this.$socket.emit("open-chrome");
        } catch (error) {
          console.log(error);
        }
      }
    },
    configureHardware() {
      this.$bvModal.show("posHardwareSettings");
      console.log("CLICKED configureHardware");
    },
    onClickStoreManagement() {
      this.getStoreManagement();
      this.$bvModal.show("userStoreManagement");
    },
    getStoreManagement() {
      if (this.CLIENT.STAR == this.CLIENT_SETUP_NAME) {
        let payload = {
          cine_id: this.getCinemaId(),
        };
        this.isStoreManagementLoading = true;
        this.storeManagementArray = [];
        this.selectedStore = {
          sm_id: null,
          sm_store_name: "",
        };
        PosService.getCinemaWiseStoreList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.storeManagementArray = data.Records.filter(
                (sm) => sm.sm_parent_id
              );
              const StoreManagementId = this.getUserShiftData("sm_id");
              console.log("selectedStore", this.selectedStore);
              this.selectedStore = this.storeManagementArray.find(
                (store) => store.sm_id == StoreManagementId
              );
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            this.isStoreManagementLoading = false;
          });
      }
    },
    updateStoreManagement(showConfirmation) {
      if (showConfirmation) {
        this.$bvModal.show("confirmation_store_update");
      } else if (!userShiftId) {
        this.$bvModal.hide("confirmation_store_update");
        this.$toasted.show("Shift ID Missing!");
      } else if (!this.selectedStore.sm_id) {
        this.$bvModal.hide("confirmation_store_update");
        this.$toasted.show("Please Select Store");
      } else {
        //Update Store
        this.showLoading();
        this.$bvModal.hide("confirmation_store_update");
        let userShiftId = this.getUserShiftData("us_id");
        let payloadObj = {
          user_shift_id: userShiftId,
          new_store_id: this.selectedStore.sm_id,
        };
        PosService.updateUserStoreManagement(payloadObj)
          .then((response) => {
            const { data } = response;
            this.$bvModal.hide("confirmation_store_update");
            if (data.status) {
              this.onLogout();
            } else {
              console.log("updateUserStoreManagement", data);
              this.$toasted.show(
                "Unable to Update Store, Please Logout and Try Again!"
              );
            }
          })
          .catch((err) => {
            console.log("Error:", err);
            console.log("updateUserStoreManagement ERROR:", err);
            this.$toasted.show(
              "Unable to Update Store, Please Logout and Try Again!"
            );
          })
          .finally(() => {
            this.hideLoading();
          });
      }
    },
    onValidateAuth() {},
    onCheckAuthentication(response) {
      const { valid, name } = response;
      console.log(name, "nameeeeeee");
      if (valid) {
        this.$bvModal.hide(name);
        console.log("First Ifffffff Valid");
        if (name == "workstationSetting") {
          this.$bvModal.show("workStationSettingModal");
        }
         if (name == "counterTypeSetting") {
          this.$bvModal.show("scheduleCounterTypeSettingModal");
        }
        if (name == "printSettings") {
          this.$bvModal.show("posPrintSettingsModal");
        }
        // if (name == "openCashDraw ") {
        //   console.log("First Ifffffff");
        //   this.openCashDrawer(name, false);
        // }
      }
    },
    onSwitchToFnb() {
      this.sendAuditLogs({
        action: `SWITCH TO FNB PAGE`,
        page_name: "POS FNB",
        api_name: window.location.hash,
      });
      this.$router.push({
        path: "/pos-fnb",
      });
    },
    onSwitchToGames() {
      this.sendAuditLogs({
        action: `SWITCH TO GAMES PAGE`,
        page_name: "POS GAMES",
        api_name: window.location.hash,
      });
      this.$router.push({
        path: "/pos-games",
      });
    },
    closeEftSession() {
      if (this.USE_TIM_INTEGRATION == "Y") {
        localStorage.setItem("ECR_INIT_STATUS", false);
        if (typeof deactivate == "function") {
          setTimeout(() => {
            deactivate();
          }, 1000);
        }
      }
    },
    onCheckShift() {
      this.loading = true;
      PosService.shiftChecker().then((response) => {
        const { data } = response;
        this.loading = false;
        if (data.status) {
          this.shiftRunning = data.shiftRunning;
        } else {
          this.shiftRunning = true;
        }
      });
    },
    getPaymentType: async function () {
      let body = {
        bs_id: 1,
      };
      MasterService.GetPaymentModes(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              let tempPaymentArray = [];

              data.Records.forEach((paymentType) => {
                paymentType["no_of_slips"] = 0;
                paymentType["amount"] = 0;
                paymentType["remark"] = "";
                tempPaymentArray.push(paymentType);
              });

              let userShiftDetails = { ...this.getUserShiftData() };
              userShiftDetails["payment_types"] = [...tempPaymentArray];
              localStorage.setItem(
                "USER_SHIFT_DATA",
                JSON.stringify(userShiftDetails)
              );
            }
          } else {
            this.toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.toasted.show(error);
        });
    },
    printPosUserCollection: async function (isPrint = true) {
      let loggedUserId = this.getUserDetail("user_id");
      let payload = {
        user_id: loggedUserId,
        fromDate: moment(this.from_date || new Date()).format("YYYY-MM-DD"),
        toDate: moment(this.to_date || new Date()).format("YYYY-MM-DD"),
        isCurrentShift: "Y",
        isPrint: isPrint,
      };
      console.log("printPosUserCollection payload", payload);
      try {
        this.showLoading();
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf(" electron/") > -1) {
          try {
            const queryString = createQueryString(payload);

            if (this.$socket && isPrint) {
              console.log(
                "socket_close_invoked",
                moment().format("YYYY-MM-DD HH:mm:ss")
              );
              if (this.authorizeClient(CLIENT_NAMES_OBJ.cinepolis)) {
                this.$socket.emit("on_print_ticket", {
                  ttype: "dynamicURL",
                  dataURL: `${BASEURL}/api/pos/getUserCollection/${loggedUserId}${queryString}`,
                });
              } else if (!this.authorizeClient(CLIENT_NAMES_OBJ.qfx)) {
                console.log("Its printing here", queryString, loggedUserId);
                this.$socket.emit("on_print_ticket", {
                  baseurl: BASEURL,
                  ttype: "pos_collection_summary",
                  user_id: loggedUserId,
                  queryString: queryString,
                });
              }
              console.log(
                "socket_close_invoked_123",
                moment().format("YYYY-MM-DD HH:mm:ss")
              );
            }

            this.hideLoading();
          } catch (err) {
            console.log("ERROR in SOcket", err);
          } finally {
            setTimeout(() => {
              this.hideLoading();
            }, 1000);
          }
        } else {
          const response = await PosService.getShiftCloseInvoiceSummary(
            payload
          );
          const { data } = response;

          console.log("printing here");
          this.EjsData = data;
          this.$nextTick(() => {
            this.hideLoading();

            if (!this.authorizeClient(CLIENT_NAMES_OBJ.qfx)) {
              const p = new Printd();
              if (this.$refs.onPrint && this.EjsData != null) {
                p.print(this.$refs.onPrint, this.EjsData);
                return;
              }
            }
          });
        }
      } catch (error) {
        console.log(error);
        this.hideLoading();
      }
    },
    onCloseShift: async function () {
      let isCloseShiftIncluded = window.localStorage.getItem("IS_SHIFT_CLOSE");
      // this.closeEftSession();
      if (isCloseShiftIncluded == "Y") {
        this.showLoading();

        try {
          await this.getPaymentType(); //gets payment modes
          if (!this.authorizeClient(CLIENT_NAMES_OBJ.novo)) {
             await this.printPosUserCollection(); //prints the shift invoice
          }
          setTimeout(async () => {
            await this.insertShiftClosePaymentData(); //updates the shift collection data and shift end.
          }, 2200);

          this.hideLoading();
        } catch (error) {
          this.$toasted.show("Shift not closed. Something went wrong.");
          this.hideLoading();
        } finally {
          setTimeout(() => {
            this.hideLoading();
          }, 100);
        }
      } else {
        window.localStorage.clear();
      }
    },
    updateShiftCloseData: async function () {
      let payload = this.getUserShiftData() || {};
      try {
        await PosService.OnClosePosUserShiftLog(payload);
      } catch (error) {
        console.log(error);
      }
    },
    insertShiftClosePaymentData: async function () {
      this.sendAuditLogs({
        action: `POS USER CLICKS SHIFT CLOSE, TOTAL CASH COLLECTED : ${
          this.getUserShiftData("grandTotal") || 0
        } ${this.curr_code_mixin}`,
        page_name: "CLOSE SHIFT",
        api_name: "",
      });
      let userRoleName = window.localStorage.getItem("USER_ROLE_NAME");
      let userShiftData = this.getUserShiftData();
      let payload = {
        operator_type:
          userRoleName == "FnB POS Operator"
            ? "pos-fnb"
            : userRoleName == "POS Operator"
            ? "pos-booking"
            : "box-office-fnb", //'pos-fnb' // 'box-office-fnb'
        shift_id: userShiftData.usl_id,
        manager_user_id: userShiftData.manager_id,
        operator_user_id: userShiftData.user_id,
        currency_id: this.getCurrencyData.curr_id,
        scr_total_amount_collected: 0,
        scr_approval_status: false,
        scr_is_active: false,
        //
        shiftClosePayments: this.getUserShiftData("payment_types") || [],
        cashDenomination: [],
        Remark: "Auto Closed Shift",
        checkSkip: true,
      };
      try {
        this.showLoading();
        const response = await PosService.onCloseShift(payload);

        const { data } = response;
        if (data && data.status) {
          await this.updateShiftCloseData();
          this.$toasted.show(data.message);
          window.localStorage.clear();
          if (userRoleName == "FnB POS Operator") {
            this.$router.push({
              path: "pos-fnb-login",
            });
          } else {
            this.$router.push({
              path: "/",
            });
          }
        } else {
          this.$toasted.show(data.message);
        }
        this.hideLoading();
      } catch (error) {
        this.$toasted.show(err);
        this.hideLoading();
      }
    },
    getPosUserLocations() {
      let defaultUserId = localStorage.getItem("DFLT_USINFO")
        ? JSON.parse(localStorage.getItem("DFLT_USINFO"))
        : null;

      let user_info = localStorage.getItem("USER_INFO")
        ? JSON.parse(localStorage.getItem("USER_INFO"))
        : null;

      this.pos_user_name = user_info.username || "";
      // console.log(pos_user_name, "pos_user_name");

      if (defaultUserId && defaultUserId["user_id"]) {
        let payload = {
          user_id: defaultUserId["user_id"],
        };
        PosService.GetPosLocationsUsers(payload)
          .then((response) => {
            const { data } = response;
            if (
              data &&
              data.status &&
              data.Records &&
              data.Records.length > 0
            ) {
              this.USERLOCATIONS = data.Records;
              let loggedUserid = this.getUserDetail("user_id");
              let loggedUser = this.USERLOCATIONS.find(
                (x) => loggedUserid == x.user_id
              );
              if (loggedUser) {
                this.selectedPosUserId = loggedUser.user_id;
                this.selectedPosUser = loggedUser;
              }
            } else {
              this.USERLOCATIONS = [];
            }
          })
          .catch((err) => {
            console.log("ERROR:", err);
          });
      } else {
        console.log(
          "COMING HERE IN ELSE getPosUserLocations",
          localStorage.getItem("DFLT_USINFO")
        );
        console.log(
          'COMING HERE IN ELSE localStorage.getItem("DFLT_USINFO").user_id',
          defaultUserId["user_id"]
        );
      }
    },
    OnChangeUserLocation(user) {
      let checkAccess = "";
      let defaultUserObj = localStorage.getItem("DFLT_USINFO")
        ? JSON.parse(localStorage.getItem("DFLT_USINFO"))
        : null;
      let defaultUserId = defaultUserObj["user_id"];
      let payload = {
        dflt_user_id: defaultUserId,
        new_user_id: user.user_id,
      };
      PosService.changeLoggedUserCinema(payload)
        .then(async (response) => {
          const { data } = response;
          console.log("data", data);
          let finalObj = {};
          let PromiseArray = this.usersArray.map((x) => {
            finalObj[x] = data.data.user[x] || null;
          });
          await Promise.all(PromiseArray);

          if (data.data.user && data.data.user.shift_id) {
            window.localStorage.setItem(
              "USER_INFO",
              finalObj ? JSON.stringify(finalObj) : {}
            );

            checkAccess = this.checkPosAccess(data.data.user);

            console.log("checkAccess", checkAccess);

            window.localStorage.setItem("JWT_TOKEN", data.data.token);

            if (
              data.hasOwnProperty("cinema_reponse") &&
              data.cinema_reponse &&
              data.cinema_reponse.length > 0 &&
              data.cinema_reponse[0].cinema_id &&
              ["4", "8"].includes(String(data.data.user.role_id))
            ) {
              window.localStorage.setItem(
                "cinema_id",
                data.cinema_reponse[0].cinema_id
              );
            } else if (["4", "8"].includes(String(data.data.user.role_id))) {
              window.localStorage.setItem("cinema_id", finalObj.cinema_id);
            }

            window.localStorage.setItem(
              "IS_SHIFT_CLOSE",
              data.data.user.cine_include_shift_close
            );

            window.localStorage.setItem("USER_ROLE_NAME", checkAccess);

            window.localStorage.setItem(
              "IS_INCLUDE_FLOAT_AMOUNT",
              data.data.user["cine_include_float_amount"]
            );

            if (checkAccess == "FNBONLY") {
              window.localStorage.setItem("isBOCalculator", false);
              await this.userShiftStart(
                {
                  usl_id: data.data.user.user_id,
                  user_shift_id: data.data.user.shift_id,
                  cine_include_shift_close:
                    data.data.user.cine_include_shift_close,
                  cine_include_float_amount:
                    data.data.user.cine_include_float_amount,
                  page_name: "FNB_LOGIN",
                },
                data.data.token
              );
            } else {
              window.localStorage.setItem("isBOCalculator", true);
              await this.userShiftStart(
                {
                  usl_id: data.data.user.user_id,
                  user_shift_id: data.data.user.shift_id,
                  cine_include_shift_close:
                    data.data.user.cine_include_shift_close,
                  cine_include_float_amount:
                    data.data.user.cine_include_float_amount,
                },
                data.data.token
              );
            }

            var userAgent = navigator.userAgent.toLowerCase();
            if (userAgent.indexOf(" electron/") > -1) {
              if (backendSocket && backendSocket.connected) {
                backendSocket.emit("on_user_login", {
                  user: data.data.user,
                  hardware_id: this.hardware_id,
                });
              }
            }

            this.sendAuditLogs({
              action: `USER CHANGE POS CINEMA LOCATION`,
              page_name: "FNB HEADER",
              api_name: window.location.hash,
            });
          } else {
            this.$toasted.show("Shift is Not Created For Selected Location");
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {
          window.localStorage.removeItem("showDataCache");
          window.localStorage.removeItem("datesArray");
          window.localStorage.removeItem("fnb_items_array");
          window.localStorage.removeItem("fnb_categories");
        });
    },
    checkPosAccess(user) {
      let status = "";
      if ([4, 8].includes(user.role_id)) {
        if (user.pos_access == "Y" && user.fnb_access == "Y") {
          status = "SUPER";
        } else if (user.pos_access == "Y" && user.fnb_access == "N") {
          status = "POSONLY";
        } else if (user.pos_access == "N" && user.fnb_access == "Y") {
          status = "FNBONLY";
        }
      } else if ([13].includes(user.role_id)) {
        if (user.order_pickup_access_only == "Y") {
          status = "PICKUPKITCHEN";
        } else {
          status = "KITCHENUSER";
        }
      }
      return status;
    },
    userShiftStart: async function (shiftUserData, token) {
      this.showLoading();
      // await commit("SET_USER_SHIFT_DETAILS", payload);

      let hardwareMacAddress = window.localStorage.getItem(
        "hardware_mac_address"
      );
      let hardwareId = window.localStorage.getItem("deiviceUniqueCode");
      // functionality remaining
      if (!hardwareId || !hardwareMacAddress) {
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf(" electron/") > -1) {
          let sys_info = await getResourceUsageInfo();
          const key = Object.keys(sys_info.macAddress)[0];
          hardwareMacAddress = sys_info.macAddress[key].mac;
        }
      }
      // functionality remaining
      let requestPayload = {
        ...this.posShiftLog,
        hardware_id: window.localStorage.getItem("HWUID")
          ? window.localStorage.getItem("HWUID")
          : window.localStorage.getItem("deiviceUniqueCode")
          ? window.localStorage.getItem("deiviceUniqueCode")
          : null,
        hardware_name: window.localStorage.getItem("hardware_name")
          ? window.localStorage.getItem("hardware_name")
          : null,
        hardware_mac_address: window.localStorage.getItem(
          "hardware_mac_address"
        )
          ? window.localStorage.getItem("hardware_mac_address")
          : hardwareMacAddress
          ? hardwareMacAddress
          : null,
      };

      var config = {
        method: "post",
        url: `${BASEURL}/api/pos/pos-user-shift-log`,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        data: JSON.stringify(requestPayload),
      };

      axios(config)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.posShiftLog = { ...this.posShiftLog, ...data.Records };
            if (data.Records.float_amount) {
              window.localStorage.setItem("FLOAT_AMOUNT_ADDED", "Y");
            } else {
              window.localStorage.setItem("FLOAT_AMOUNT_ADDED", "N");
            }

            if (shiftUserData["cine_include_float_amount"] == "N") {
              window.localStorage.setItem("FLOAT_AMOUNT_ADDED", "Y");
            }
            window.localStorage.setItem(
              "USER_SHIFT_DATA",
              JSON.stringify(this.posShiftLog)
            );
            window.localStorage.setItem(
              "USER_SHIFT_ID",
              this.posShiftLog.usl_id
            );

            if (!data.Records["inserted_new"]) {
              // USE WHEN WE NEED TO FORCE CLOSE SHIFT
              // router.replace({
              //     path: "close-shift"
              // });

              if (
                shiftUserData["page_name"] &&
                shiftUserData["page_name"] == "FNB_LOGIN"
              ) {
                console.log("route to pos-fnb");
                this.$router
                  .replace({
                    path: "/pos-fnb",
                  })
                  .catch((error) => {
                    if (
                      error.name !== "NavigationDuplicated" &&
                      !error.message.includes(
                        "Avoided redundant navigation to current location"
                      )
                    ) {
                      throw new Error(error);
                    } else {
                      window.location.reload();
                      console.log("Redundant navigation to current location");
                    }
                  });
              } else {
                this.$router
                  .replace({
                    path: "/pos-booking",
                  })
                  .catch((error) => {
                    if (
                      error.name !== "NavigationDuplicated" &&
                      !error.message.includes(
                        "Avoided redundant navigation to current location"
                      )
                    ) {
                      throw new Error(error);
                    } else {
                      window.location.reload();
                      console.log("Redundant navigation to current location");
                    }
                  });
              }
            } else if (
              shiftUserData["page_name"] &&
              shiftUserData["page_name"] == "FNB_LOGIN"
            ) {
              if (
                shiftUserData["cine_include_float_amount"] &&
                shiftUserData["cine_include_float_amount"] == "Y"
              ) {
                console.log("route to pos-fnb-cash");
                this.$router
                  .replace({
                    path: "/pos-cash-input",
                    query: { nextRoute: "FNB_LOGIN" },
                  })
                  .catch((error) => {
                    if (
                      error.name !== "NavigationDuplicated" &&
                      !error.message.includes(
                        "Avoided redundant navigation to current location"
                      )
                    ) {
                      throw new Error(error);
                    } else {
                      window.location.reload();
                      console.log("Redundant navigation to current location");
                    }
                  });
              } else {
                console.log("route to pos-fnb");
                this.$router
                  .replace({
                    path: "/pos-fnb",
                  })
                  .catch((error) => {
                    if (
                      error.name !== "NavigationDuplicated" &&
                      !error.message.includes(
                        "Avoided redundant navigation to current location"
                      )
                    ) {
                      throw new Error(error);
                    } else {
                      window.location.reload();
                      console.log("Redundant navigation to current location");
                    }
                  });
              }
            } else if (
              shiftUserData["cine_include_float_amount"] &&
              shiftUserData["cine_include_float_amount"] == "Y"
            ) {
              this.$router
                .replace({
                  path: "/pos-cash-input",
                  query: { nextRoute: "POS_LOGIN" },
                })
                .catch((error) => {
                  if (
                    error.name !== "NavigationDuplicated" &&
                    !error.message.includes(
                      "Avoided redundant navigation to current location"
                    )
                  ) {
                    throw new Error(error);
                  } else {
                    window.location.reload();
                    console.log("Redundant navigation to current location");
                  }
                });
            } else {
              this.$router
                .replace({
                  path: "/pos-booking",
                })
                .catch((error) => {
                  if (
                    error.name !== "NavigationDuplicated" &&
                    !error.message.includes(
                      "Avoided redundant navigation to current location"
                    )
                  ) {
                    throw new Error(error);
                  } else {
                    window.location.reload();
                    console.log("Redundant navigation to current location");
                  }
                });
            }
            // window.location.reload();
          } else {
          }
        })
        .catch((error) => {})
        .finally(() => {
          setTimeout(() => {
            this.hideLoading();
          }, 1000);
        });
    },
    lockWorkstation() {
      window.localStorage.setItem("IS_WORKSTATION_LOCKED", "true");
      EventBus.$emit("LOCK_WORKSTATION");
    },
    lockScreen() {
      this.lockWorkstation();
    },
    onClickModal() {
      this.$bvModal.show("confirmation_active_inactive");
    },
    configureSetting() {
      this.$bvModal.show("posSettingsModal");
    },
    configureWorkStationSetting(authCheck = true) {
      if (authCheck && this.MANAGER_AUTH_FOR_CHANGES == "Y") {
        this.$bvModal.show("workstationSetting");
      } else {
        this.$bvModal.show("workStationSettingModal");
      }
    },
     configureCounterTypeSetting(authCheck = true) {
      // if (authCheck && this.MANAGER_AUTH_FOR_CHANGES == "Y") {
      //   this.$bvModal.show("counterTypeSetting");
      // } else {
      //   this.$bvModal.show("scheduleCounterTypeSettingModal");
      // }
      this.$bvModal.show("scheduleCounterTypeSettingModal");
    },
    configurePrintSettings(authCheck = true) {
      if (authCheck && this.MANAGER_AUTH_FOR_CHANGES == "Y") {
        this.$bvModal.show("printSettings");
      } else {
        this.$bvModal.show("posPrintSettingsModal");
      }
    },
    updateShiftLogoutData: async function () {
      let shiftData = localStorage.getItem("USER_SHIFT_DATA");
      if (shiftData) {
        let payload = JSON.parse(shiftData);
        PosService.OnQuitPosUserShift(payload)
          .then((response) => {
            console.log("user logged out");
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    onLogout: async function () {
      this.sendAuditLogs({
        action: `POS USER CLICKS LOGOUT BUTTON`,
        page_name: "LOGOUT",
        api_name: "",
      });

      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
        if (backendSocket && backendSocket.connected) {
          backendSocket.emit("on_user_logout", {
            hardware_id: this.DeviceUniqueCode,
          });
        }
      }

      window.localStorage.clear();

      this.$router.push({
        path: "/",
      });
    },
    // openCashDrawer: function(menu_name, authCheck = true) {
    //   if (menu_name == "openCashDraw") {
    //     if (authCheck && this.MANAGER_AUTH_FOR_CHANGES == "Y") {
    //       this.$bvModal.show("openCashDraw");
    //     }
    //     try {
    //       this.sendAuditLogs({
    //         action: `POS USER OPEN CASH DRAWER`,
    //         page_name: "CASH DRAWER",
    //         api_name: "",
    //       });
    //       let cinema_id = localStorage.getItem("cinema_id");
    //       let userData = localStorage.getItem("USER_INFO") || "";
    //       if (this.$socket) {
    //         console.log(
    //           "print_ticket from pos_login3123425454 open cash drawer"
    //         );
    //         this.$socket.emit("on_print_ticket", {
    //           cinema_id,
    //           baseurl: BASEURL,
    //           ttype: "empire-login-ticket",
    //           openDrawer: "Y",
    //           loginDateTime: userData,
    //         });
    //         console.log("print_ticket from pos_login");
    //       }
    //     } catch (error) {
    //       console.log(error);
    //     }
    //   }
    // },
    openCashDrawer: async function (menu_name, authCheck = true) {
      if (menu_name === "openCashDraw") {
        if (authCheck && this.MANAGER_AUTH_FOR_CHANGES === "Y") {
          await this.$bvModal.show("openCashDraw");
        }
      }
    },
  },
};
</script>

<style>
.disableLocation {
  opacity: 0.5;
  cursor: not-allowed;
}

#userStoreManagement___BV_modal_content_ {
  zoom: 0.8;
}

.noHoverBtn:hover {
  color: white !important;
  background-color: var(--blue) !important;
}

.loader {
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 25px;
  height: 25px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 10px;
}

.alignment-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 48px;
  flex-wrap: nowrap;
}

.pos-header-left,
.pos-header-center,
.pos-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.pos-header-left {
  flex: 0 0 auto;
}

.pos-header-center {
  flex: 1 1 auto;
  justify-content: center;
}

.pos-header-right {
  flex: 0 0 auto;
  justify-content: flex-end;
  margin-left: auto;
}

.pos-header-user-menu {
  flex: 0 0 auto;
  flex-shrink: 0;
  margin-left: 8px;
}

.pos-header-logo {
  display: inline-flex;
  align-items: center;
  margin-right: 4px;
}

.pos-header-datetime {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  line-height: 1.2;
  color: #4a4a4a;
  font-size: 11px;
  font-weight: 500;
}

.pos-header-date {
  color: var(--blue);
}

.pos-header-datetime-sep {
  opacity: 0.45;
}

.pos-header-time {
  color: #333;
}

.pos-header-lock-btn {
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid #d7dce3;
  border-radius: 6px;
  background: #ffffff;
  color: var(--blue);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  margin-right: 2px;
  transition: all 0.15s ease;
}

.pos-header-lock-btn:hover {
  background: #f3f7fc;
  border-color: var(--blue);
  color: var(--blue);
}

.pos-header-lock-btn:active {
  transform: scale(0.95);
  background: #eaf0f9;
}

.pos-header-lock-icon {
  display: block;
}

.pos-filter-btn {
  width: 34px;
  height: 34px;
  padding: 0;
  border: 1px solid #d7dce3;
  border-radius: 6px;
  background: #fff;
  color: var(--blue);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.pos-filter-btn:hover {
  background: #f3f7fc;
  border-color: var(--blue);
}

.pos-filter-icon {
  display: block;
}

.pos-sort-dropdown {
  flex-shrink: 0;
}

.pos-sort-dropdown .btn.pos-sort-toggle {
  display: inline-flex !important;
  align-items: center;
  gap: 5px;
  height: 34px;
  padding: 0 9px !important;
  border: 1px solid #d7dce3;
  border-radius: 6px;
  background: #fff;
  color: var(--blue);
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
}

.pos-sort-dropdown .btn.pos-sort-toggle:hover {
  border-color: var(--blue);
  background: #f3f7fc;
}

.pos-sort-icon {
  display: block;
  flex-shrink: 0;
}

.pos-sort-label {
  max-width: 96px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pos-sort-arrow {
  color: #333;
  font-size: 13px;
  font-weight: 700;
}

.pos-sort-menu {
  min-width: 190px;
  font-size: 13px;
}

.pos-sort-header {
  color: #8a8f98;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}

.pos-sort-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.pos-sort-item-arrow {
  font-weight: 700;
}

.pos-header-user-menu .btn,
.pos-header-dropdown .btn {
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
  padding: 2px 6px !important;
  border-radius: 6px;
}

.pos-header-user-label {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 600;
}

.pos-header-user-icon {
  color: var(--blue);
  flex-shrink: 0;
}

@media screen and (min-width: 1100px) {
  .main {
    gap: 10px;
  }
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.disabled-click {
  cursor: not-allowed;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/posHeader.vue